<template>
    <div>
        <ComPageHeader title="earn_money" :type="1" @close="handleBack" />
        <div class="earn">
            <!-- <div class="earn-title"></div> -->
            <div class="earn-panel">
                <div class="panel-data">
                    <div class="data-item" v-for="item in panelData" :key="item.key" @click="showDetail(item)">
                        <div class="data-name">{{ $t(item.text) }} <IconFont class="text-[#8eaaba]" name="jiantou"></IconFont></div>
                        <div class="data-num">
                            <template v-if="item.key !== 'total'">+</template>{{ store.cureencySymbol()
                            }}{{ Math.floor((panelDatas[item.key] || 0) * 100) / 100 }}
                        </div>
                    </div>
                </div>
                <div class="balance-title">
                    {{ $t('earncash.earncash_available') }}
                    <van-popover class="pop" v-model:show="showPopover" placement="bottom">
                        <div
                            class="pop-text"
                            v-html="
                                $t('earncash.earncash_available_info1', {
                                    number: panelDatas?.transConfig?.flowmult || 0,
                                    number2: panelDatas?.transConfig?.payoutRate || 0,
                                })
                            "
                        ></div>
                        <template #reference>
                            <IconFont class="text-[#8eaaba]" name="gantanhao"></IconFont>
                        </template>
                    </van-popover>
                </div>
                <div class="balance-num">{{ store.cureencySymbol() }}{{ formatmoney(panelDatas?.current || 0) }}</div>
                <div class="btn-wrap">
                    <div class="btn" v-for="item in withDrawConfig" :key="item.type" @click="handleWithDraw(item)">
                        <p>{{ $t(item.text) }}</p>

                        <p style="font-size: 10px">
                            ({{ item.rate === 'goldRate' ? '1:1' : 'X' + (panelDatas?.transConfig ? panelDatas?.transConfig[item.rate] : 0) }})
                        </p>
                    </div>
                </div>
            </div>
            <div class="earn-title">{{ $t('earncash.tasks') }}</div>
            <div class="task">
                <Server :offset-top="450" />
                <div v-for="(item, index) in baseInfo.data.tasks" :key="index" :class="['task-detail', { 'task-total': item.type === 'totalearn' }]">
                    <img class="task-icon" :src="item.icon" />
                    <div class="detail-right">
                        <div class="top">
                            <p v-html="$t(item.name, { current_type: store.cureencySymbol(), number: item.require, vip_level: item.require })"></p>
                            <p>+{{ store.cureencySymbol() }}{{ item.reward }}</p>
                        </div>
                        <div :class="['bot', { 'items-end': item.type !== 'totalearn' }]">
                            <template v-if="item.type !== 'totalearn'">
                                <div class="num-wrap">
                                    <p class="task-des" v-if="item.type !== 'totalearn'">{{ $t(item.desc) }}</p>
                                    <div class="num">
                                        <!-- <div v-if="!item.repeat" class="user" @click="handleUser(item)"> -->
                                        <div v-if="!item.repeat" class="user"><IconFont name="renxiang"></IconFont>{{ item.users }}</div>
                                        <div class="money">
                                            <!-- <div class="money" @click="handleMoney"> -->
                                            <IconFont name="qian"></IconFont>{{ formatmoney(item.totalReward || 0) }}
                                        </div>
                                    </div>
                                </div>
                                <div class="bot-btn" @click="handleTaskClick(item)">
                                    {{ $t('earncash.earn_details') }}
                                </div>
                            </template>
                            <template v-else>
                                <p class="des">
                                    {{
                                        item.totalReward / item.require >= 1
                                            ? $t('earncash.earned_salary_info2')
                                            : $t(item.desc, {
                                                  current_type: store.cureencySymbol(),
                                                  number: item.require,
                                              })
                                    }}
                                </p>
                                <div v-if="item.totalReward / item.require < 1" class="bar-wrap">
                                    <div class="bar">
                                        <div class="bar-inner" :style="{ width: `${(item.totalReward / item.require) * 100}%` }"></div>
                                    </div>
                                    <span class="rate">{{ `${item.totalReward}/${item.require}` }}</span>
                                </div>
                                <div v-else class="btn" @click="joinGroup">{{ $t('earncash_join_group') }}</div>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="task_invite">
                    <div class="invites_btn" @click="handleTaskClick({ type: 'allinvite', id: '' })">
                        <div class="svg-icon">
                            <svg aria-hidden="true">
                                <use href="#icon-svg-Howworks" fill="#b3bec1"></use>
                            </svg>
                        </div>

                        {{ $t('earncash.earned_invite') }}
                    </div>
                    <div class="toinvite_btn" @click="showShare = true">
                        <div class="svg-icon toinvite">
                            <svg aria-hidden="true">
                                <use href="#icon-svg-wallet-earncash" fill="#604402"></use>
                            </svg>
                        </div>

                        {{ $t('earncash.earn_to_invite') }}
                    </div>
                </div>
            </div>
            <div class="top-title">
                <p>{{ $t('earncash.Top_earners') }}</p>
                <div @click="dialogVisible.rank = true">{{ $t('more') }}<IconFont class="text-[#8eaaba]" name="jiantou"></IconFont></div>
            </div>
            <div class="earner">
                <div class="earner-item" v-for="(item, index) in baseInfo.topRank" :key="index">
                    <div class="avatar-wrap">
                        <div class="avatar"><img :src="item.avatar" /></div>
                        <div class="num"></div>
                    </div>
                    <div class="name">{{ encryptUsername(decodeName(item.nickname)) }}</div>
                    <div class="money">+{{ store.cureencySymbol() }}{{ formatNumberKMB(item.score) }}</div>
                </div>
            </div>
            <div class="rule-title">
                {{ $t('earnMoney_rule_title') }}
            </div>
            <p class="rule-content" v-html="$t('earncash.earned_rules_info1')"></p>
        </div>
        <Rank v-if="dialogVisible.rank" @onClose="dialogVisible.rank = false" />
        <EarnDetail v-model="dialogVisible.detail" />
        <TaskPop v-model="taskPop.invite" type="invite" :id="taskPop.id" />
        <TaskPop v-model="taskPop.firstpay" type="firstpay" :id="taskPop.id" />
        <TaskPop v-model="taskPop.vip" type="vip" :id="taskPop.id" />
        <TaskPop v-model="taskPop.bet" type="bet" :id="taskPop.id" />
        <TaskPop v-model="taskPop.allinvite" type="allinvite" />
        <InputPop v-model="withDrawPop.exchange" :data="baseInfo.data" @exchangeFinish="exchangeFinish" />
        <ComShareDialog v-model="showShare" from="earncash" :social="['facebook', 'telegram', 'viber', 'link']" />
        <WithDrawPop v-model="withDrawPop.withDraw" :data="baseInfo.data" @exchangeFinish="exchangeFinish" />
    </div>
</template>
<script setup lang="ts">
import { getEarnStatsV2, getRankTop, getNotLoginRankTop } from '@/api/earnCash'
import { useBaseStore } from '@/stores'
import { Log } from '@/api/log'
import { formatmoney, formatNumberKMB, openUrl } from '@/utils/toolsValidate'
import { decodeName, encryptUsername, checkLogin } from '@/utils'
import Rank from '@/components/earnMoney/rank.vue'
import { EarnStatsV2 } from '@/api/earnCash/types'
import EarnDetail from '@/components/earnMoney/earnDetail.vue'
import TaskPop from '@/components/earnMoney/taskPop.vue'
import InputPop from '@/components/earnMoney/inputPop.vue'
import WithDrawPop from '@/components/earnMoney/withDrawPop.vue'
import eventBus from '@/utils/bus'
import { useI18n } from 'vue-i18n'
import Server from '@/components/server.vue'
import ShareDialog from '@/components/dialog/shareDialog.vue'
import ComPageHeader from '@/components/common/ComPageHeader.vue'
import IconFont from '@/plugins/iconfont/IconFont.vue'
import ComShareDialog from '@/components/dialog/ComShareDialog.vue'

const store = useBaseStore()
const route = useRoute()
const router = useRouter()
const i18n = useI18n()

const withDrawConfig = [
    {
        type: 1,
        text: 'earncash.earncash_exchange',
        rate: 'goldRate',
    },
    {
        type: 2,
        text: 'wallet_Withdrawal',
        rate: 'payoutRate',
    },
]
const showPopover = ref(false)
const showShare = ref(false)
const baseInfo = reactive<{ data: Partial<EarnStatsV2>; rate: number; topRank: any[] }>({
    data: {},
    rate: 0,
    topRank: [],
})
const panelDatas = computed(() => baseInfo.data)
const dialogVisible = reactive({
    rank: false,
    detail: false,
})
const taskPop = reactive({
    invite: false,
    firstpay: false,
    vip: false,
    bet: false,
    allinvite: false,
    id: '',
})
const withDrawPop = reactive({
    exchange: false,
    withDraw: false,
})

const panelData = [
    {
        key: 'today',
        text: 'Today',
    },
    {
        key: 'monthly',
        text: 'Month_Earned',
    },
    {
        key: 'total',
        text: 'Total_Earned',
    },
]

const handleBack = async () => {
    router.back()
}

const showDetail = (item) => {
    checkLogin().then(() => {
        if (item.key !== 'total') {
            return
        }
        dialogVisible.detail = true
    })
}

const getBaseData = () => {
    getEarnStatsV2().then((res) => {
        if (res.code === 200) {
            baseInfo.data = res.data
            // oildUserTip()
        }
    })
}
const exchangeFinish = (num) => {
    baseInfo.data.current = num
}

const init = () => {
    getBaseData()
    if (store.token) {
        getRankTop({
            start: 0,
            stop: 2,
        }).then((res) => {
            if (res.code === 200) {
                baseInfo.topRank = res.data.populars.members.map((item) => {
                    return { ...item, score: res.data.populars.scores[item.uid] }
                })
            }
        })
    } else {
        getNotLoginRankTop({
            start: 0,
            stop: 2,
        }).then((res) => {
            if (res.code === 200) {
                baseInfo.topRank = res.data.populars.members.map((item) => {
                    return { ...item, score: res.data.populars.scores[item.uid] }
                })
            }
        })
    }
}

const handleMoney = () => {
    checkLogin().then(() => {
        dialogVisible.detail = true
    })
}
const handleUser = (item) => {
    checkLogin().then(() => {
        taskPop[item.type] = true
        taskPop.id = item.id
    })
}
const handleTaskClick = (item) => {
    checkLogin().then(() => {
        // if (item.type === 'invite') {
        //     return (showShare.value = true)
        // }
        handleUser(item)
    })
}
const joinGroup = () => {
    console.log(baseInfo.data)

    openUrl(baseInfo.data.service)
}
const handleWithDraw = (item) => {
    checkLogin().then(() => {
        if (item.type === 1) {
            withDrawPop.exchange = true
        } else {
            withDrawPop.withDraw = true
        }
    })
}
const oildUserTip = () => {
    if (baseInfo.data.bean) {
        showDialog({
            // title: i18n.t('earncash_new_info1'),
            message: i18n.t('earncash.earncash_new_info2'),
            className: 'common-dialog earn-dialog',
            showCancelButton: false,
            confirmButtonText: i18n.t('Confirm'),
            cancelButtonText: i18n.t('Cancel'),
        })
    }
}
onMounted(() => {
    eventBus.on('updateEarnMoney', exchangeFinish)
})

onActivated(() => {
    Log({
        event: 'earn_visit',
    })
    init()
})
onBeforeUnmount(() => {
    eventBus.off('updateEarnMoney', exchangeFinish)
})
</script>
<style scoped lang="scss">
.earn {
    height: calc(var(--vh, 1vh) * 100 - var(--home-header)) !important;
    padding: 0 26px var(--footer-height);
    overflow: auto;
    .earn-title {
        padding-top: 10px;
        line-height: 66px;
        font-size: 30px;
        font-weight: 800;
        color: #fff;
    }

    .earn-panel {
        margin-top: 20px;
        height: 400px;
        padding: 19px 30px 21px;
        border-radius: 30px;
        background: linear-gradient(0deg, rgba(62, 251, 150, 0) 20.29%, rgba(44, 238, 136, 0.5) 100%), #2a2d3d;

        .panel-data {
            @apply flex gap-[8px];

            .data-item {
                @apply flex flex-col justify-center items-center;
                width: 208px;
                height: 100px;
                border-radius: 8px;
                background: rgba(32, 35, 46, 0.6);
                text-align: center;

                .data-name {
                    font-size: 24px;
                    color: #fff;

                    .anticon {
                        display: none;
                    }
                }
                .data-num {
                    color: #ffea76;
                    font-size: 32px;
                    font-weight: 700;
                }
                &:first-child {
                    border-radius: 20px 8px 8px 20px;
                }

                &:last-child {
                    border-radius: 8px 20px 20px 8px;

                    .data-name {
                        .anticon {
                            display: inline-block;
                            color: #fff;
                        }
                        position: relative;
                        &::before {
                            content: '';
                            position: absolute;
                            bottom: 0;
                            left: 0;
                            width: 100%;
                            height: 2px;
                            background-color: #fff;
                        }
                    }
                }
            }
        }
        .balance-title {
            @apply flex justify-center items-center gap-[12px];
            height: 60px;
            color: #fff;
            text-align: center;
            font-size: 22px;
            font-weight: 400;
            span {
                font-size: 25px;
            }
            &::before {
                display: inline-block;
                content: '';
                width: 32px;
                height: 32px;
                background: url('@/assets/img/earn-cash/earn_gold.png') no-repeat;
                background-size: 100% 100%;
            }
        }
        .balance-num {
            margin: 0 auto;
            width: 440px;
            height: 64px;
            border-radius: 50px;
            background: #20232e;
            color: #ffea76;
            text-align: center;
            font-size: 42px;
            font-weight: 700;
        }
        .btn-wrap {
            @apply flex gap-[20px] mt-[30px];

            .btn {
                @apply flex flex-col justify-center items-center;
                width: 310px;
                height: 90px;
                border-radius: 14px;
                background: linear-gradient(90deg, #2aee88 0%, #9ae871 100%), linear-gradient(#8b0500, #8b0500);
                box-shadow: 0 0 0.16rem rgba(35, 238, 136, 0.3), inset 0 -0.05333rem #1dca6a;
                color: #000;
                font-size: 32px;
                font-weight: 800;

                &:last-child {
                    background-image: linear-gradient(90deg, #fffc7f 0%, #ffdc6d 100%), linear-gradient(#8b0500, #8b0500);
                    box-shadow: 0 0 0.16rem rgba(255, 187, 0, 0.376), inset 0 -0.05333rem rgb(255, 187, 0, 0.376);
                }
            }
        }
    }
    .task {
        position: relative;
        .home-server {
            position: absolute;
            top: -85px !important;
            right: -20px !important;
        }
        .task_invite {
            height: 100px;
            // border: 2px dashed #414b4c;
            align-items: center;
            justify-content: space-between;
            display: flex;
            font-weight: 800;
            font-size: 28px;
            color: #fff;

            .svg-icon {
                width: 32px;
                height: 32px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .toinvite {
                width: 36px;
                height: 36px;
            }

            .invites_btn {
                width: 39%;
                height: 75px;
                border-radius: 15px;
                background-color: #414b4c;
                background-size: 100% 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 12px;
            }
            .toinvite_btn {
                width: 55%;
                height: 75px;
                border-radius: 15px;
                background-image: linear-gradient(90deg, #fffc7f 0%, #ffdc6d 100%), linear-gradient(#8b0500, #8b0500);
                box-shadow: 0 0 0.16rem rgba(255, 187, 0, 0.376), inset 0 -0.05333rem rgb(255, 187, 0, 0.376);
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 12px;
                color: #000;
            }
        }
    }
    .task-detail {
        @apply flex;
        margin-bottom: 11px;
        padding: 19px 20px 0 0;
        height: 149px;
        border-radius: 30px;
        background: linear-gradient(270deg, rgba(44, 238, 136, 0) 30.29%, rgba(44, 238, 136, 0.2) 100%), #2a2d3d;
        color: #fff;

        .task-icon {
            width: 110px;
        }

        .detail-right {
            flex: 1;

            .top,
            .bot {
                @apply flex justify-between;
                // height: 60px;
                & > div:first-child {
                    flex: 1;
                }
            }
            .top {
                font-size: 26px;
                font-weight: 400;

                & p:last-child {
                    color: #ffea76;
                    font-size: 30px;
                    font-weight: 700;
                }
                :deep(.text-yellow) {
                    color: #ffea76;
                }
            }
            .task-des {
                color: #ffea76;
                font-size: 20px;
                font-weight: 400;
            }
            .bot {
                // @apply items-end;
                .num-wrap {
                    @apply flex flex-col justify-between;
                }
                .num {
                    @apply flex justify-start items-end  gap-[10px];
                    margin-top: 5px;
                    color: #fff;
                    font-size: 24px;
                    font-weight: 400;
                    .anticon {
                        color: #8eaaba;
                    }

                    .user,
                    .money {
                        @apply flex items-center box-border gap-[4px];
                        min-width: 162px;
                        height: 36px;
                        padding: 0 13px;
                        color: #fff;
                        font-size: 24px;
                        font-weight: 400;
                        border-radius: 50px;
                        background: rgba(0, 0, 0, 0.4);
                    }
                }
                .bot-btn {
                    @apply flex justify-center items-center;
                    width: 180px;
                    height: 60px;
                    border-radius: 14px;
                    background: linear-gradient(90deg, #2aee88 0%, #9ae871 100%), linear-gradient(#8b0500, #8b0500);
                    box-shadow: 0 0 0.16rem rgba(35, 238, 136, 0.3), inset 0 -0.05333rem #1dca6a;
                    border-radius: 14px;
                    color: #000;
                    font-size: 26px;
                    font-weight: 400;
                }
            }
        }
    }
    .task-total {
        @apply flex;
        background: linear-gradient(270deg, rgba(44, 238, 136, 0.04) 0%, rgba(44, 238, 136, 0.12) 30.29%, rgba(44, 238, 136, 0.4) 100%), #2a2d3d;

        .bot {
            @apply flex-col;
        }
        .des {
            margin: 2px 0;
            color: #ffea76;
            font-size: 20px;
            font-weight: 400;
        }
        .bar-wrap {
            @apply flex items-center gap-[8px];
            // margin-top: 8px;
            .bar {
                flex: 1;
                height: 36px;
                border-radius: 50px;
                background: rgba(0, 0, 0, 0.4);
                overflow: hidden;
                .bar-inner {
                    height: 100%;
                    border-radius: 50px;
                    background: linear-gradient(90deg, #2aee88 0%, #9ae871 100%);
                }
            }
            .rate {
                color: #ffea76;
                -webkit-text-stroke-width: 1px;
                -webkit-text-stroke-color: rgba(0, 0, 0, 0.6);
                font-size: 26px;
                font-weight: 400;
            }
        }

        .btn {
            @apply flex justify-center items-center;
            margin-left: auto;
            width: 265px;
            height: 44px;
            border-radius: 50px;
            background: linear-gradient(90deg, #2aee88 0%, #9ae871 100%);
            color: #000;
            font-size: 26px;
            font-weight: 400;
        }
    }
    .top-title {
        @apply flex items-center;

        p {
            flex: 1;
            color: #fff;
            font-size: 30px;
            font-weight: 400;
            line-height: 74px;
        }
        div {
            position: relative;
            color: #8eaaba;
            font-size: 26px;
            font-weight: 600;
            align-items: center;
            display: inline-flex;

            &::before {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                height: 2px;
                content: '';
                background: #8eaaba;
            }
        }
    }
    .earner {
        @apply flex justify-center gap-[2px] items-end;
        height: 298px;
        padding-bottom: 10px;
        border-radius: 30px;
        background: url('@/assets/img/earn-cash/earn_bg.png') lightgray 50% / cover no-repeat;

        .earner-item {
            @apply flex flex-col justify-end items-center;
            position: relative;
            width: 220px;
            height: 140px;
            padding-bottom: 10px;
            border-radius: 20px;
            background: linear-gradient(180deg, rgba(152, 224, 255, 0.4) 0%, rgba(152, 224, 255, 0) 100%), #3a3f51;
            box-shadow: 0px 2px 0px 0px rgba(188, 253, 255, 0.25) inset;

            .avatar-wrap {
                position: absolute;
                top: -94px;
                left: 50%;
                width: 128px;
                height: 128px;
                border-radius: 50%;
                transform: translateX(-50%);

                .avatar {
                    width: 120px;
                    height: 120px;
                    border-radius: 120px;
                    border: 4px solid #ffb8a8;
                    overflow: hidden;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
                .num {
                    position: absolute;
                    left: 50%;
                    bottom: -3px;
                    width: 75px;
                    height: 36px;
                    background: url('@/assets/img/earn-cash/top1.png') no-repeat;
                    background-size: 100% 100%;
                    transform: translateX(-50%);
                }
            }
            &:nth-child(1) {
                order: 2;
                height: 151px;
                padding-top: 11px;
                background: linear-gradient(180deg, rgba(255, 209, 85, 0.7) 0%, rgba(255, 209, 85, 0) 100%), #3a3f51;
                box-shadow: 0px 2px 0px 0px rgba(255, 253, 188, 0.35) inset;

                .avatar-wrap {
                    .avatar {
                        border-color: #fe9;
                    }
                }
            }
            &:nth-child(2) {
                order: 1;
                .avatar-wrap {
                    .avatar {
                        border-color: #ebeef1;
                    }
                }
                .num {
                    background-image: url('@/assets/img/earn-cash/top2.png');
                }
            }
            &:nth-child(3) {
                order: 3;
                background: linear-gradient(180deg, rgba(221, 128, 107, 0.6) 0%, rgba(221, 128, 107, 0) 100%);
                box-shadow: 0px 2px 0px 0px rgba(255, 212, 212, 0.25) inset;
                .num {
                    background-image: url('@/assets/img/earn-cash/top3.png');
                }
            }

            .name {
                color: #fff;
                font-size: 26px;
                font-weight: 600;
            }
            .money {
                @apply flex items-center justify-center;
                width: 187px;
                height: 36px;
                border-radius: 50px;
                background: #20232e;
                color: #ffea76;
                font-size: 30px;
                font-weight: 600;
            }
        }
    }
    .rule-title {
        line-height: 80px;
        color: #fff;
        font-size: 30px;
        font-weight: 400;
    }
    .rule-content {
        padding-bottom: 20px;
        color: #fff;
        font-size: 24px;
        font-weight: 400;
        :deep(.d1) {
            color: #4cff5d;
        }
        :deep(.d2) {
            color: #5cceff;
        }
    }
}
.pop {
    :deep(.van-popover__content) {
        padding: 0 0 0 30px;
        width: 666px;
        transform: translateX(-13%);
    }
    .pop-text {
        padding: 34px;
        font-size: 32px;
        :deep(li) {
            padding-left: 10px;
        }
    }
}

:global(.earn-dialog) {
    // padding-top: 0 !important;
}

:global(.earn-dialog .van-dialog__content .van-dialog__message) {
    text-align: left;
}
</style>
